import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { ReportPermissionsListViewComponent } from './report-permissions-list-view.component';

@NgModule({
   declarations: [ReportPermissionsListViewComponent],
   exports: [ReportPermissionsListViewComponent],
   imports: [
      CommonModule,
      MatCheckboxModule,
      MatFormFieldModule,
      FormsModule,
      MatIconModule,
      MatInputModule,
      AddSpacesPipeModule,
   ],
})
export class ReportPermissionsListViewModule {}
